"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VENTURE_PROMPTS_TO_SHOW = exports.UNAVAILABLE = exports.SEARCH_RECOMMENDATION_ITC = exports.REQUEST_STATUS = exports.PROMPT_ID = exports.MAX_RECOMMENDATIONS = exports.MAX_AUTO_COMPLETE_LENGTH = exports.MATCH_SOURCE = exports.APP_NAME = void 0;
const MAX_RECOMMENDATIONS = exports.MAX_RECOMMENDATIONS = 30;
const APP_NAME = exports.APP_NAME = 'domain-search-box';
const SEARCH_RECOMMENDATION_ITC = exports.SEARCH_RECOMMENDATION_ITC = 'domain_search_box_search_recommendation';
const MAX_AUTO_COMPLETE_LENGTH = exports.MAX_AUTO_COMPLETE_LENGTH = 10;
const VENTURE_PROMPTS_TO_SHOW = exports.VENTURE_PROMPTS_TO_SHOW = 2;
const UNAVAILABLE = exports.UNAVAILABLE = 'UNAVAILABLE';
const REQUEST_STATUS = exports.REQUEST_STATUS = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  LOADING: 'LOADING',
  INIT: 'INIT',
  UNAVAILABLE: 'UNAVAILABLE'
};
const PROMPT_ID = exports.PROMPT_ID = {
  VENTURE: 'venture',
  PORTFOLIO: 'portfolio',
  COMPACT: 'compact',
  COUNTRY: 'country'
};
const MATCH_SOURCE = exports.MATCH_SOURCE = {
  PORTFOLIO: /^pf/,
  CC_TLD: /^(em.cctld)$|^(serp.e.ccb)$/,
  COMPACT: /^em.cmpct$/
};